<template>
  <div class="modalbox-content">
    <div class="section-label">Descrições</div>
    <div class="form-group">
      <label class="field-label">
        Descrição Completa
        <BadgeErp campo="descricaocompleta" :camposSincronizados="camposSincronizados" />
      </label>
      <CInput v-model="item.descComp" />
    </div>
    <div class="form-group">
      <label class="field-label">
        Descrição Nota Fiscal
        <BadgeErp campo="descricaonf" :camposSincronizados="camposSincronizados" />
      </label>
      <CInput v-model="item.descNF" />
    </div>
    <div class="form-group">
      <label class="field-label">
        Descrição Força de Vendas
        <BadgeErp campo="descricaofv" :camposSincronizados="camposSincronizados" />
      </label>
      <CInput v-model="item.descricaofv" />
    </div>
    <div class="form-group">
      <label class="field-label">
        Descrição de Busca
        <BadgeErp campo="descricaobusca" :camposSincronizados="camposSincronizados" />
      </label>
      <CInput v-model="item.descricaobusca" />
    </div>
    <div class="form-group">
      <label class="field-label">Observação</label>
      <CTextarea rows="3" v-model="item.observacao" />
    </div>

    <div class="section-label">Classificação</div>
    <v-row>
      <v-col cols="4">
        <label class="field-label">Tipo</label>
        <CSelect
          :value="item.tipo"
          @update:value="item.tipo = $event"
          :options="tipoOptions"
        />
      </v-col>
      <v-col cols="8">
        <div class="toggles-card">
          <div class="toggle-row">
            <span class="toggle-row__label">Genérico</span>
            <label class="toggle-switch">
              <input type="checkbox" :checked="!!item.generico" @change="item.generico = $event.target.checked ? 1 : 0" />
              <span class="toggle-slider"></span>
              <span class="toggle-text">{{ item.generico ? 'Sim' : 'Não' }}</span>
            </label>
          </div>
          <div class="toggle-row">
            <span class="toggle-row__label">
              Ativo
              <BadgeErp campo="ativo" :camposSincronizados="camposSincronizados" />
            </span>
            <label class="toggle-switch">
              <input type="checkbox" :checked="!!item.ativo" @change="item.ativo = $event.target.checked ? 1 : 0" />
              <span class="toggle-slider"></span>
              <span class="toggle-text">{{ item.ativo ? 'Sim' : 'Não' }}</span>
            </label>
          </div>
        </div>
      </v-col>
    </v-row>

    <div class="section-label">Códigos e Referências</div>
    <v-row>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">
            Código de Barras
            <BadgeErp campo="codbarraunitario" :camposSincronizados="camposSincronizados" />
          </label>
          <CInput v-model="item.codBarra" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">
            Código Fabricante
            <BadgeErp campo="codigofabricante" :camposSincronizados="camposSincronizados" />
          </label>
          <CInput v-model="item.codigofabricante" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">
            Código de Referência
            <BadgeErp campo="codigoreferencia" :camposSincronizados="camposSincronizados" />
          </label>
          <CInput v-model="item.codigoreferencia" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">
            Classificação Fiscal (NCM)
            <BadgeErp campo="classificacaofiscal" :camposSincronizados="camposSincronizados" />
          </label>
          <CInput v-model="item.classificacaofiscal" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">
            Fornecedor ID
            <BadgeErp campo="fornecedor_id" :camposSincronizados="camposSincronizados" />
          </label>
          <CInput v-model="item.fornecedor_id" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">
            Marca ID
            <BadgeErp campo="marca_id" :camposSincronizados="camposSincronizados" />
          </label>
          <CInput v-model="item.marca_id" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">Modelo ID</label>
          <CInput v-model="item.modelo_id" />
        </div>
      </v-col>
      <v-col cols="6">
        <div class="form-group">
          <label class="field-label">Produto Principal ID</label>
          <CInput v-model="item.produtoprincipal_id" />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BadgeErp from "@/components/BadgeErp";

export default {
  name: "InformacoesGerais",
  components: { BadgeErp },
  props: {
    item: { type: Object, required: true },
    camposSincronizados: { type: Array, default: () => [] },
  },
  data() {
    return {
      tipoOptions: [
        { value: "P", label: "Produto" },
        { value: "G", label: "Grupo de Produto" },
      ],
    };
  },
};
</script>

<style scoped>
.field-label {
  font-size: 11px;
  font-weight: 600;
  color: #667085;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 3px;
  display: block;
}

.section-label {
  font-size: 11px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 12px 0 8px;
  padding-top: 12px;
  border-top: 1px solid #e9ecef;
}

.form-group {
  margin-bottom: 12px;
}

.toggles-card {
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  padding: 4px 16px;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
}

.toggle-row:last-child {
  border-bottom: none;
}

.toggle-row__label {
  font-size: 13px;
  color: #333;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
  flex-shrink: 0;
}

.toggle-switch input {
  display: none;
}

.toggle-slider {
  position: relative;
  width: 36px;
  height: 20px;
  background-color: #ccc;
  border-radius: 20px;
  transition: background-color 0.2s;
  flex-shrink: 0;
}

.toggle-slider::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: transform 0.2s;
}

.toggle-switch input:checked + .toggle-slider {
  background-color: #3a3e81;
}

.toggle-switch input:checked + .toggle-slider::after {
  transform: translateX(16px);
}

.toggle-text {
  font-size: 12px;
  color: #777;
  min-width: 28px;
}
</style>
